import { GetOrdersResponse, GetOrdersResponseItem } from './types';
import { SetOrdersPayload } from '../actions/orders.types';
import { Order, OrderType } from '../../types';

export const mapGetOrdersResponseToSetOrdersPayload = (response: GetOrdersResponse): SetOrdersPayload => {
  const transformedOrdersByType: SetOrdersPayload['ordersByType'] = {};

  Object.keys(response.ordersByType || {}).forEach((orderTypeKey: string) => {
    const orderType = orderTypeKey as OrderType;
    const group = response.ordersByType[orderType];

    if (group) {
      transformedOrdersByType[orderType] = {
        orders: group.orders.map(
          (item: GetOrdersResponseItem): Order => ({
            id: item.orderID,
            type: item.orderType,
            deliveryMethod: item.deliveryMethod,
            destination: item.destination,
            quantity: item.quantity,
            finalizationErrorCode: item.finalizationErrorCode,
            finalizationErrorMessage: item.finalizationErrorMessage,
            isRetryEnabled: item.isRetryEnabled,
            isUpcScanRequired: item.isUpcScanRequired,
            date: item.date,
            sequenceNumber: item.orderSequenceNumber,
            recallDescription: item.recallDescription,
            recallType: item.recallType,
            supplierID: item.supplierID,
            dispatchTime: item.dispatchTime
          })
        ),
        pickTours: group.pickTours,
        sortOrder: group.sortOrder,
      };
    }
  });

  return {
    ordersByType: transformedOrdersByType,
  };
};
